<template>
	<form class="form" @submit.prevent="sendToPreview" novalidate>
		<ValidationAlert :error-list="errors.collect('server')" />
		<fieldset class="form__group">
			<FormControlContentType
                name="type"
                v-model="formData.type"
                v-validate="'required'"
            />
			<div class="form__group">
				<textarea
                    id="summary"
                    name="summary"
                    class="form__control"
                    v-model="formData.description"
                    placeholder="Enter your summary here..."
                    v-validate
                    required
                />
				<label for="summary" class="form__label">Summary</label>
				<div class="form__validation">{{ errors.first('summary') }}</div>
			</div>
			<FileUpload
                id="files"
                v-model="formData.attachments"
                name="attachments"
                :multiple="true"
                v-validate
                required
                ref="fileinput"
            />
			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='["submit", "files uploading"]'>Back</button>
				<button class="btn btn--primary" @click.prevent="sendToPreview" v-wait:disabled='["submit", "files uploading"]'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import ValidationAlert from '@components/ValidationAlert';
	import FileUpload from '@components/Form/FileUpload';
	import FormControlContentType from '@components/Form/Control/FormControlContentType';
	import InsightFormStep from './InsightFormStep';

	export default {
		name: 'InsightFormStep3',
		mixins: [InsightFormStep],
		components: {
			FormControlContentType,
			FileUpload,
			ValidationAlert,
		},
		data() {
			return {
				formData: {
					type: null,
					description: null,
                    attachments: [],
				}
			}
		},
	}
</script>
